import RenderWasm from './renderWasm'
import { nanoid } from 'nanoid'
import { anchorsListStore } from '@/store/anchorsListStore' // 数字人数据存完的位置
import { timelineStore } from '@/store/timelineStore'
import common from '@/utils/common'
import { useVideoEditorStore } from '@/store/videoEditorStore'

export default class RenderCanvas extends RenderWasm {
	// 对wasm的封装层在这里编写
	// 如果在这里进行里封装 期望将wasm相对应的方法更改为私有方法
	anchorsListStoreState
	timelineStoreState
	videoEditStore
	editorCanvas = null
	constructor() {
		super()
		this.anchorsListStoreState = anchorsListStore()
		this.timelineStoreState = timelineStore()
		this.videoEditStore = useVideoEditorStore()
	}

	// 添加卡片 顺便添加默认数字人
	addCard(obj) {
		let { card_name = 'add_card_' + '-' + nanoid(), duration = 10 } = {
			...obj
		}
		super.addCard(card_name, duration)
		return card_name
	}
	// 更新背景
	upDateBgDu(maxTime) {
		if (!this.timelineStoreState.getBgClip[0]) return
		const id = this.timelineStoreState.getBgClip[0].id
		super._updateClipSequence(id, 0, maxTime)
		this.timelineStoreState.getAiHuamListByCard.map(ite => {
			if (ite.isFollowCardDuration) super._updateClipSequence(ite.id, 0, maxTime)
		})
	}
	// 更新其他跟随时间线的clip
	// 更新时间线
	setAllCardAuration(time) {
		// console.log('setAllCardAuration')
		// 设置时间线时常  super.updateClipSequence(clip_name, sequenceIn, sequenceOut)
		if (this.timelineStoreState.getAiHuamListByCard) {
			// this.timelineStoreState.getAiHuamListByCard.map((ite) => {
			//   if (!ite.isFollowCardDuration) {
			// 设置卡片时长
			this.timelineStoreState.getCardList.forEach((card, index) => {
				if (!card.track_list[0]?.clip_list) return
				let maxTime = 0
				card.track_list[0].clip_list.forEach(clip => {
					const isFollowCardDuration = this.timelineStoreState.getAiHuamListByClipName(clip.id)
						.isFollowCardDuration
						? this.timelineStoreState.getAiHuamListByClipName(clip.id).isFollowCardDuration
						: false
					// console.log(clip.sequnce_out, clip.id, 'maxTime', isFollowCardDuration);
					if (clip.sequnce_out > maxTime && !isFollowCardDuration) {
						if (clip.id?.split('_')[1] !== 'ai') maxTime = clip.sequnce_out
					}
					// 背景单处理
					// if(clip.id.split("_")[1] === "background" && clip.sequnce_out > maxTime) maxTime = clip.sequnce_out
				})
				if (time > maxTime) {
					maxTime = time
				}
				maxTime = maxTime ? maxTime : 10
				this.upDateBgDu(maxTime)
				super.updateCardDuration(card.id, maxTime)
				this.serializableJson()
			})
		}

		//   });
		// }
		// this.serializableJson();
	}

	// 添加图片
	addImageClip(obj) {
		let {
			card_name = this.timelineStoreState.getCardName,
			clip_name = 'my_image_clip' + '-' + nanoid(),
			res_uuid = 'my_image_clip' + '-' + nanoid(),
			file_path,
			sequenceIn = 0,
			sequenceOut = this.timelineStoreState.getActiveCardDuration
		} = { ...obj }
		if (!card_name || !file_path) {
			return
		}
		super.addImageClip(card_name, clip_name, res_uuid, file_path, sequenceIn, sequenceOut)
		this.updateClipPositon(clip_name)
		// this.setAllCardAuration();
		return clip_name
	}

	// 添加视频 TODO
	async addVideoClip(obj) {
		let {
			card_name = this.timelineStoreState.getCardName,
			clip_name = obj.clip_name || 'my_video_clip' + '-' + nanoid(),
			file_path,
			sequenceIn = 0,
			sequenceOut = obj.duration ? obj.duration : this.timelineStoreState.getActiveCardDuration
		} = { ...obj }
		if (!card_name || !file_path) {
			return
		}
		// 多媒体数据
		// file_path = await this.downloadMedia(file_path, res_uuid);
		super.addAvClip(card_name, clip_name, file_path, sequenceIn, sequenceOut)
		if (clip_name.split('_')[1] === 'audioG') {
			super.updateAvClipVolume(clip_name, 0.5 * 0.7) // 降低背景音
		} else {
			super.updateAvClipVolume(clip_name, 0)
		}
		this.updateClipPositon(clip_name)
		super.updateClipZindex(clip_name, -1)
		return clip_name
		// this.setAllCardAuration(sequenceOut);
		// this.timelineStoreState.getAihuamByClip.duration = sequenceOut
	}

	// 添加文字
	addTextClip(obj) {
		// const language_ttf=JSON.parse(localStorage.getItem("language_data")).targetTtfUrl language_ttf?language_ttf:"https://source.wengegroup.com/mam2/6162da06e4b0726539a4450f.otf",
		let {
			card_name = this.timelineStoreState.getCardName,
			clip_name = 'my_text_clip' + '-' + nanoid(),
			font_uuid = 'my_text_clip' + '-' + nanoid(),
			font_path = 'https://source.wengegroup.com/mam2/6162da06e4b0726539a4450f.otf',
			text = '添加标题',
			size,
			sequenceIn = 0,
			sequenceOut = this.timelineStoreState.getActiveCardDuration
		} = { ...obj }
		if (!card_name) {
			return
		}
		font_path = font_path.replace(/^http:/, 'https:')
		super.addTextClip(
			card_name,
			clip_name,
			font_uuid,
			font_path,
			text,
			size,
			sequenceIn,
			sequenceOut
		)
		let x = this.videoEditStore.getVideoRatio === '9:16' ? 540 : 960
		let y = this.videoEditStore.getVideoRatio === '9:16' ? 960 : 540
		this.updateClipPositon(clip_name, x, y)
		// this.setAllCardAuration();
		// 浅色主题添加黑色字
		this.updateTextFontColor({ clip_name, color: '#000000' })
		// if(this.timelineStoreState.getTheme === "light"){
		//   this.updateTextFontColor({ clip_name, color:"#000000"});
		// } else {
		//   this.updateTextFontColor({ clip_name, color:"#ffffff"});
		// }
		// 深色主题添加白色
	}
	splitStringByLength(start, length) {
		let result = []
		let currentIndex = 0
		while (currentIndex < start.length) {
			let endIndex = currentIndex + length
			// 如果 endIndex 超出了字符串长度，直接添加最后的部分
			if (endIndex >= start.length) {
				result.push(start.substring(currentIndex))
				break
			}
			// 向前移动 endIndex，寻找空格
			while (endIndex > currentIndex && start[endIndex] !== ' ') {
				endIndex--
			}
			// 如果没有找到空格，endIndex 设置为 currentIndex + length
			if (endIndex === currentIndex) {
				endIndex = currentIndex + length
			}
			// 提取子字符串并去除两端空格
			result.push(start.substring(currentIndex, endIndex).trim())
			// 更新 currentIndex 为 endIndex
			currentIndex = endIndex
			// 跳过空格
			while (currentIndex < start.length && start[currentIndex] === ' ') {
				currentIndex++
			}
		}

		return result
	}
	splitStringByLengthText(start, length) {
		let result = ''
		let currentIndex = 0
		while (currentIndex < start.length) {
			let endIndex = currentIndex + length
			// 如果 endIndex 超出了字符串长度，直接添加最后的部分
			if (endIndex >= start.length) {
				result += start.substring(currentIndex)
				break
			}
			// 向前移动 endIndex，寻找空格
			while (endIndex > currentIndex && start[endIndex] !== ' ') {
				endIndex--
			}
			// 如果没有找到空格，endIndex 设置为 currentIndex + length
			if (endIndex === currentIndex) {
				endIndex = currentIndex + length
			}
			// 提取子字符串并去除两端空格
			result += start.substring(currentIndex, endIndex).trim()
			// 更新 currentIndex 为 endIndex
			currentIndex = endIndex
			// 跳过空格
			while (currentIndex < start.length && start[currentIndex] === ' ') {
				currentIndex++
			}
			// 如果 currentIndex 还小于 start 的长度，添加换行符
			if (currentIndex < start.length) {
				result += '\n'
			}
		}
		return result
	}
	// 添加字幕
	addCaptions(obj) {
		const { captionStyle } = this.timelineStoreState
		let {
			card_name = this.timelineStoreState.getCardName,
			clip_name = 'my_caption_clip' + '-' + nanoid(),
			font_uuid = 'my_caption_clip' + '-' + nanoid(),
			font_path = obj.path ? obj.path : captionStyle.font,
			text = '添加字幕',
			color = captionStyle.color,
			size = captionStyle.size,
			sequenceIn = 0,
			sequenceOut = this.timelineStoreState.getActiveCardDuration
		} = { ...obj }
		if (!card_name) {
			return
		}
		if (!color) {
			color = '#000000'
		}
		font_path = font_path.replace(/^http:/, 'https:')
		super.addTextClip(
			card_name,
			clip_name,
			font_uuid,
			font_path,
			this.splitStringByLengthText(text, 20),
			size,
			sequenceIn,
			sequenceOut
		)

		let x = this.videoEditStore.getVideoRatio === '9:16' ? 540 : 960
		let y = this.videoEditStore.getVideoRatio === '9:16' ? 1700 : 1020
		const fullNum = this.splitStringByLength(text, 20)
		if (fullNum.length) {
			y = y - fullNum.length * 20
		}

		// 更改描边颜色
		super.updateTextFontStrokeColor(clip_name, 0.0, 0.0, 0.0)

		// 更改描边粗细e
		super.updateTextFontStrokeSize(clip_name, 3)

		this.updateClipPositon(clip_name, x, y)
		// 浅色主题添加黑色字
		this.updateTextFontColor({ clip_name, color })

		super.updateClipZindex(clip_name, 9999)
		// this.setAllCardAuration();
		// 深色主题添加白色
	}

	// language_ttf?language_ttf:"https://source.wengegroup.com/mam2/6162da06e4b0726539a4450f.otf",
	// 添加 视频 翻译字幕
	addVideoTranslateCaptions(obj) {
		const { captionStyle } = this.timelineStoreState
		// console.log("!!!!!!!!!!!!!!!!!",language_ttf)
		let {
			card_name = this.timelineStoreState.getCardName,
			clip_name = 'my_caption_clip' + '-' + nanoid(),
			font_uuid = 'my_caption_clip' + '-' + nanoid(),
			font_path,
			text = '添加字幕',
			color = captionStyle.color,
			size = captionStyle.size,
			sequenceIn = 0,
			sequenceOut = this.timelineStoreState.getActiveCardDuration
		} = { ...obj }
		if (!card_name) {
			return
		}
		if (!color) {
			color = '#000000'
		}
		// font_path = font_path.replace(/^http:/, "https:");
		super.addTextClip(
			card_name,
			clip_name,
			font_uuid,
			font_path,
			text,
			size,
			sequenceIn,
			sequenceOut
		)
		let x = this.videoEditStore.getVideoRatio === '9:16' ? 540 : 960
		let y = this.videoEditStore.getVideoRatio === '9:16' ? 1500 : 900

		const imgClip = clip_name + '-bg'
		super.addImageClip(
			card_name,
			imgClip,
			'res_uuid',
			'https://source.wengegroup.com/bucket-yoya/html/background_grey.png',
			sequenceIn,
			sequenceOut
		)
		// this.updateClipPositon(clip_name + '-bg', x, y);
		this.updateClipPositon(imgClip, x, y + 28)
		super.updateClipZindex(imgClip, 998)
		super.updateClipScale(imgClip, 3, 0.1)
		y = obj.hight ? obj.hight : y
		this.updateClipPositon(clip_name, x, y)
		// 浅色主题添加黑色字
		this.updateTextFontColor({ clip_name, color })
		// this.setAllCardAuration();
		// 深色主题添加白色
	}
	// 添加转场
	addTransition(obj) {
		let {
			transition_name = 'my_transition' + '-' + nanoid(),
			a_clip_id = obj.a_card_id,
			b_clip_id = obj.b_card_id,
			transition_type = 'CROSS_DISSOLVE',
			transitionMode
		} = { ...obj }
		super.addTransition(transition_name, a_clip_id, b_clip_id, transition_type)
		if (transition_type === 'MOVE_AROUND') {
			this.setTransitionMode(transition_name, transitionMode)
		}
	}

	// 添加滤镜
	addFilter(obj) {
		let {
			clip_name,
			filter_name = 'my_filter' + '-' + nanoid(),
			filter_type,
			sequenceIn = 0,
			sequenceOut = 1
		} = { ...obj }
		if (!clip_name || !filter_name) {
			return
		}
		super.addFilter(filter_name, clip_name, filter_type, sequenceIn, sequenceOut)
	}

	// 删除转场
	removeTransition(obj) {
		let { transition_name } = { ...obj }
		if (!transition_name) return
		super.removeTransition(transition_name)
	}

	// 删除滤镜
	removeFilter(obj) {
		let { filter_name } = { ...obj }
		if (!filter_name) return
		super.removeFilter(filter_name)
	}

	// 更改clip位置
	updateClipPositon = (clip_name, x, y) => {
		if (!clip_name) return
		if (x === undefined) {
			x = this.videoEditStore.getVideoRatio === '9:16' ? 540 : 960
		}
		if (y === undefined) {
			y = this.videoEditStore.getVideoRatio === '9:16' ? 960 : 540
		}
		super.updateClipPositon(clip_name, x, y)
	}

	// 更改clip播放时间
	updateClipSequence(obj) {
		let {
			clip_name,
			sequenceIn = 0,
			sequenceOut = this.timelineStoreState.getActiveCardDuration
		} = { ...obj }
		if (!clip_name) return
		super._updateClipSequence(clip_name, sequenceIn, sequenceOut)
	}

	// 更新(滤镜/动画)
	updateFilterSequence(obj) {
		let { filter_name, sequenceIn = 0, sequenceOut = 0 } = { ...obj }
		if (!filter_name) return
		super.updateFilterSequence(filter_name, sequenceIn, sequenceOut)
	}

	// 更新文字对齐方式
	updateTextAlignType = obj => {
		const { clip_name, align_type } = obj
		super.updateTextAlignType(clip_name, align_type)
	}

	// 更新文字颜色
	updateTextFontColor = obj => {
		const { clip_name, color } = obj
		const colrGroup = common.colorRgb(color)
		const r = colrGroup[0] / 255
		const g = colrGroup[1] / 255
		const b = colrGroup[2] / 255
		super.updateTextFontColor(clip_name, r, g, b)
	}

	// 更新字幕字体
	updateCaptionsFontPath(obj) {
		let { clip_name, font_path = '' } = { ...obj }
		if (!clip_name || !font_path) return
		const bufferUrl = font_path.replace(/^http:/, 'https:')
		// super.updateTextFontPath(clip_name, bufferUrl)
		// // 缓存字幕字体
		this.timelineStoreState.captionStyle.font = font_path
		// 更新所有字幕
		this.timelineStoreState.getCardList.forEach(card => {
			card.track_list[0].clip_list.forEach(clip => {
				if (clip.id.split('_')[1] === 'caption') {
					super.updateTextFontPath(clip.id, bufferUrl)
				}
			})
		})
	}

	// 更新字幕大小
	updateCaptionsFontSize(obj) {
		let { clip_name, size = 20 } = { ...obj }
		if (!clip_name || !size) return
		// super.updateTextFontSize(clip_name, size)
		// // 缓存字幕大小
		this.timelineStoreState.captionStyle.size = size
		// 更新所有字幕
		this.timelineStoreState.getCardList.forEach(card => {
			card.track_list[0].clip_list.forEach(clip => {
				if (clip.id.split('_')[1] === 'caption') {
					super.updateTextFontSize(clip.id, size)
				}
			})
		})
	}

	// 更新字幕颜色
	updateCaptionsFontColor(obj) {
		const { clip_name, color } = obj
		if (!clip_name || !color) return
		const colrGroup = common.colorRgb(color)
		const r = colrGroup[0] / 255
		const g = colrGroup[1] / 255
		const b = colrGroup[2] / 255
		// // 缓存字幕颜色
		this.timelineStoreState.captionStyle.color = color
		// 更新所有字幕
		this.timelineStoreState.getCardList.forEach(card => {
			card.track_list[0].clip_list.forEach(clip => {
				if (clip.id.split('_')[1] === 'caption') {
					super.updateTextFontColor(clip.id, r, g, b)
				}
			})
		})
	}

	// 设置音频声音
	updateAvClipVolume = obj => {
		const { clip_name, volume } = obj
		if (!clip_name) return
		super.updateAvClipVolume(clip_name, volume)
	}

	// 更新卡片时长
	updateCardDuration = obj => {
		const { card_name = this.timelineStoreState.getCardName, duration } = obj
		super.updateCardDuration(card_name, duration)

		// 更新完之后也要更新背景
	}

	// 更新timeline
	serializableJson() {
		const timeline = this._serializableJson()
		this.timelineStoreState.updateTimelineDiscript(timeline)
		return timeline
	}

	playSdk() {
		this.videoEditStore.setPlaying(true)
		super.play()
	}

	// 重播
	rePlay() {
		const audioPlayer = document.getElementById('audioG')
		if (this.timelineStoreState.globalAudio?.res_path) {
			audioPlayer.currentTime = 0
		}
		this.seek(0)
		this.timelineStoreState.setActiveCardIndex(0)
		new Promise(res => {
			res()
		}).then(() => {
			this.play()
		})
	}

	pauseSdk() {
		this.videoEditStore.setPlaying(false)
		super.pause()
	}

	async downloadMedia(url, randomID) {
		const bufferUrl = url.replace(/^http:/, 'https:')
		const fileExtension = bufferUrl.split('.').pop().toLowerCase()
		const bufferName = randomID + '.' + fileExtension
		// 渲染loading
		if (fileExtension === 'm3u8') return url // m3u8 不用处理
		const res = await fetch(bufferUrl)
		const arrayBuffer = await res.arrayBuffer()
		const uint8Array = new Uint8Array(arrayBuffer)
		super.writeArraybufferToMemfs(bufferName, uint8Array)

		// 有些非m3u8的多媒体资源 草稿模板等进入的时候 需要下载 存放在aiHuman中
		// const currentHuman = this.timelineStoreState.getCurrentHuman;
		return bufferName
	}
}
